<template>
<div>
  <transparentheaders ref="brother"></transparentheaders>
  
    <div class="loginbox">
      <!-- <img class="white" src="../assets/images/whitebox.png" /> -->
      <!-- <img class="big" src="../assets/images/登录.png"> -->
      <div class="logincontent">
        <div class="userlogin">登录系统</div>

        <el-input placeholder="请输入用户名" v-model="username">
          <i slot="prefix"><img  src="../assets/images/user.png" /></i>
        </el-input>
        <el-input placeholder="请输入密码" v-model="pwd" show-password>
          <i slot="prefix"><img class="icon" src="../assets/images/password.png" /></i>
        </el-input>
        <!-- <div class="demo-input-suffix">
          <el-input class="input3" placeholder="请输入验证码" v-model="verify">
            <i slot="prefix"><img src="../assets/images/assurecode.png"/></i>
          </el-input>
          <img src="../assets/images/sure.png" />
        </div> -->

        <el-button type="primary" @click="success()">立即登录</el-button>
        <div class="account">
          还没有账户，请先 <router-link to="/reg" @click="jump">注册</router-link>
        </div>
        <div class="greet">
          <span class="line"></span><span class="txt">客服电话:&nbsp; 021-66532456</span><span class="line"></span>
        </div>
      </div>
    
  </div>

</div>
</template>

<script>
import {
  login
} from "../api/api";
import transparentheaders from "../components/transparentheaders.vue"

export default {
  data() {
    return {
      username: "",
      pwd: "",
      verify: "",

      msg: "", //弹出的消息

    };
  },
  components: {
    transparentheaders,
  },
  methods: {
    login() {
      let data = {
        username: this.username,
        password: this.pwd,
        captcha: "pc"
      };
      // console.log(data);
      login(data).then(res => {
        if (res.data.code == 200) {
          this.msg = res.data.message;
          this.open();
          this.$router.push({
            path: "/"
          });
          const token = res.data.result.token;
          const userinfo = res.data.result.userInfo;
          var userinfo_Data = JSON.stringify(userinfo);
          this.$store.commit("set_token", token);
          this.$store.commit("setUserInfo", userinfo_Data);
         
        }
        if (res.data.code == 500) {
          this.msg = res.data.message;
          console.log(res.data.message);
          this.open();
        }
      });
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {});
    },
    success() {
      var passwordreg = /^[a-zA-Z\d]{6,16}$/;

      if (!passwordreg.test(this.pwd)) {
        this.msg = "密码应为6-16位字符";
        this.open();;
      }
      if (this.username === "") {
        this.msg = "用户名不能为空";
        this.open();

      }

      if (!(!passwordreg.test(this.pwd) || this.username === "")) {
        this.login();
        // this.msg = this.finalmsg;
        // console.log(this.msg);

      }

    },
    jump() {
      this.$refs.borther.change()
    }
  },

};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: auto;
}

.userlogin {
  padding: 5px;

  margin-bottom: 15px;
  font-size: 36px;
  font-family: "SourceHanSansCN";
  color: rgb(56, 56, 56);
  line-height: 1.5;
}

.loginbox {
  width: 100%;
  height: 100vh;
  background-image: url(../assets/images/login.png);
  background-size: cover;
  z-index: -1;
}

.logincontent {
  padding: 40px;
  // width: 473px;
  // height: 590px;
  position: fixed;
  top: 23%;
  right: 20%;
  z-index: 1;
  // border: solid 1px red;
  margin-right: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: white;
  box-shadow: 0px 0px 20px 0px rgba(10, 108, 255, 0.2);
  border-radius: 20px;

  //   border:solid 1px red
}

.el-input {
  width: 275px;
  height: 60px;
  margin-bottom: 10px;
}

>>>.el-input__inner {
  background-color: rgb(242, 249, 255);
  border: none;
  border-radius: 10px;
}

.input3 {
  width: 165px;
}

>>>.el-input--prefix .el-input__inner {
   padding-left: 43px;
    padding-top: 3.5px;
}

.el-button {
  width: 275px;
  height: 50px;
  margin-top: 10px;
  color: #fff;
  background-color: rgb(10, 108, 255);
  border-color: rgb(10, 108, 255);
  border-radius: 10px;

  font-size: 18px;
}

// .big img{
// width:1920px;
//     height: 1080px;
// }
.white {
  width: 476px;
  height: 590px;
  position: fixed;
  top: 23%;
  right: 17%;
  z-index: 0;
}

.greet {
  font-size: 15px;
  font-family: "Microsoft YaHei";
  color: rgb(163, 163, 163);
  line-height: 3.6;
  text-align: left;
  position: relative;
  height: 60px;
}

.greet .line {
  display: inline-block;
  width: 70px;
  border-top: 1px solid rgb(163, 163, 163);
}

.greet .txt {
  color: rgb(163, 163, 163);
  vertical-align: -4px;
  margin: 10px;
}

.account {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(163, 163, 163);
  line-height: 3.857;
  text-align: left;
}

.account a {
  text-decoration: underline;
  color: rgb(55, 158, 237);
}

i img {
  margin: 10px;
}

.router-link-active {
  border: solid 1px blue;
}

>>>.el-input__suffix {
  height: 0%;
}
.icon {
  margin-left: 13.5px;
}
</style>
<!-- .矩形_2 {
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 0px 20px 0px rgba(10, 108, 255, 0.2);
  position: absolute;
  left: 1059px;
  top: 231px;
  width: 478px;
  height: 592px;
  z-index: 21;
} -->



// WEBPACK FOOTER //
// src/components/loginbackground.vue